
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import endPoint from "../../websitecomponents/redux/EndPoint/endpoint";
import { toast } from "react-toastify";
import SellerLoader from "../Util/SellerLoader.jsx";

const ViewProduct = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);

    const fetchProducts = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("SellerTokenData");
            const response = await axios.get(endPoint.SellerGetProduct, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log("response:", response?.data);
            if (response.status === 200) {
                setProducts(response.data.products);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleCloseModal = () => setSelectedImage(null);

    const _handleDelete = async (product) => {
        if (window.confirm(`Are you sure you want to delete the product: ${product?.title}?`)) {
            try {
                setLoading(true);
                const token = localStorage.getItem("SellerTokenData");
                const response = await axios.delete(`${endPoint.SellerDeleteProduct}/${product._id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (response.status === 200) {
                    toast.success("Product deleted successfully");
                    fetchProducts();
                }
            } catch (error) {
                console.error("Error deleting product:", error);
            }
            finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="w-full overflow-x-auto bg-white ">
            {products?.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-black mt-[15%]">
                    <img
                        src={require("../../assets/images/icons/logo3.png")}
                        alt="No Products"
                        className="w-40 h-40 mb-4"
                    />
                    <p className="text-lg font-semibold">You Have Not Uploaded Any Product</p>
                </div>
            ) :
                (
                    <div className="p-1 w-full">
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            <div className="">
                                <table className="w-max table-auto border-collapse border min-w-full">
                                    <thead className="bg-gray-100 sticky top-0">
                                        <tr>
                                            {[
                                                "Title",
                                                "Brand",
                                                "Category",
                                                "SKU",
                                                "GTIN",
                                                "Price",
                                                "Commission Amount",
                                                "Final Price",
                                                "Stock",
                                                "Description",
                                                "Specifications",
                                                "Variations",
                                                "Images",
                                                "Created At",
                                                "Actions",
                                            ].map((header) => (
                                                <th
                                                    key={header}
                                                    className="border p-3 text-left whitespace-nowrap"
                                                >
                                                    {header}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {products?.map((p) => (
                                            <tr key={p._id} className="border-t hover:bg-gray-50">
                                                <td className="p-3">{p?.title}</td>
                                                <td className="p-3">{p?.brand}</td>
                                                <td className="p-3">{p?.category}</td>
                                                <td className="p-3">{p?.sku}</td>
                                                <td className="p-3">{p?.gtin}</td>
                                                <td className="p-3">₹{p?.salePrice || p?.regularPrice}</td>
                                                <td className="p-3">₹{p?.commissionAmount}</td>
                                                <td className="p-3">{p?.finalPrice}</td>
                                                <td className="p-3">{p?.stock}</td>
                                                <td className="p-3 w-64 overflow-hidden">{p?.description}</td>
                                                <td className="p-3">
                                                    {p?.specifications?.length
                                                        ? p?.specifications.map((s) => `${s.key}: ${s.value}`).join(", ")
                                                        : "-"}
                                                </td>
                                                <td className="p-2 ">
                                                    {p?.variations?.length ? (
                                                        <div className="flex flex-wrap gap-2">
                                                            {p?.variations.map((v, index) => (
                                                                <div key={index} className="flex flex-col items-center p-1 rounded">
                                                                    {/* Display first image if exists */}
                                                                    {v.images?.length ? (
                                                                        <img
                                                                            src={v.images[0]}
                                                                            alt={v.variationTitle || "variation image"}
                                                                            className="w-12 h-12 object-cover rounded"
                                                                        />
                                                                    ) : (
                                                                        <div className=" flex items-center justify-center text-gray-500 text-xs">
                                                                            No Image
                                                                        </div>
                                                                    )}
                                                                    {/* Variation info */}
                                                                    <span className="text-xs text-center mt-1">
                                                                        {v.variationTitle || "-"} <br />
                                                                        {v.color || "-"}, ₹{v.price}, Stock: {v.stock}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                                <td className="p-2 flex gap-2">
                                                    {[p.productimage1, p.productimage2, p.productimage3].map(
                                                        (img, i) =>
                                                            img && (
                                                                <img
                                                                    key={i}
                                                                    src={img}
                                                                    alt=""
                                                                    className="w-20 h-20 object-cover rounded cursor-pointer"
                                                                    onClick={() => setSelectedImage(img)}
                                                                />
                                                            )
                                                    )}
                                                </td>
                                                <td className="p-2">{new Date(p.createdAt).toLocaleString()}</td>
                                                <td className="p-2 space-x-1">
                                                    <button
                                                        className="bg-blue-500 text-white px-2 py-1 rounded text-sm"
                                                        onClick={() => toast.info("Edit functionality coming soon")}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button onClick={() => _handleDelete(p)} className="bg-red-500 text-white px-2 py-1 rounded text-sm">
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Image Modal */}
                        <Modal show={!!selectedImage} onHide={() => setSelectedImage(null)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Preview</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <img src={selectedImage} alt="" className="w-full" />
                            </Modal.Body>
                        </Modal>
                    </div>
                )
            }

            {/* Image Modal */}
            <Modal show={!!selectedImage} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img src={selectedImage} alt="" className="w-full" />
                </Modal.Body>
            </Modal>

            {loading && (<SellerLoader />)}
        </div >
    );
};

export default ViewProduct;
